import type { GetUserResAccountWorkspacesItemDto } from '../../generated';

export const isPersonalWorkspace = (
    workspace: GetUserResAccountWorkspacesItemDto
) => {
    return workspace.membership.group.type === 'individual';
};
